<template>
  <header class="main-header">
    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top" :class="{ 'hidden-navbar': !showNavbar }">
      <img src="/static/img/svg/menu.svg" class="menu-ora" @click="showSlider()" />
      <!-- Sidebar toggle button-->
   <!-- Boton que amplia el sidebar
      <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a> -->
      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu">
        <!-- Fecha de hoy -->
          <label v-if="window.width > 400" class="fechaNav" style="text-transform:capitalize">{{new Date() | formatDate('dddd DD')}}</label>
          <label v-if="window.width > 400" class="fechaNav" style="padding-left:5px; padding-right:5px;">de</label>
          <label v-if="window.width > 400" class="fechaNav" style="text-transform:capitalize">{{new Date() | formatDate('MMM YYYY')}}</label>
        <ul class="nav navbar-nav">    
          <!-- User Account: style can be found in dropdown.less -->
          <li class="dropdown user user-menu dropdown-per">
            <a href="#" class="dropdown-toggle nav-user-info" data-toggle="dropdown">
              <img src="/static/img/svg/people.svg" class="user-image img-color" alt="User Image">
              <span class="hidden-xs user-label">{{ userInfo.name.toLowerCase().trim() }} </span>
            </a>            
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
const OFFSET = 60

export default {
  data () {
    return {
      window: {
        width: 0,
        height: 0
      },
      showNavbar: true,
      lastScrollPosition: 0,
      scrollValue: 0
    }
  },
  name: 'va-navibar',
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    this.lastScrollPosition = window.pageYOffset
    window.addEventListener('scroll', this.onScroll)
    const viewportMeta = document.createElement('meta')
    viewportMeta.name = 'viewport'
    viewportMeta.content = 'width=device-width, initial-scale=1'
    document.head.appendChild(viewportMeta)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    onScroll () {
      if (window.pageYOffset < 0) {
        return
      }
      if (Math.abs(window.pageYOffset - this.lastScrollPosition) < OFFSET) {
        return
      }
      // this.showNavbar = window.pageYOffset < this.lastScrollPosition
      this.lastScrollPosition = window.pageYOffset
    },
    showSlider () {
      $('#slider').addClass('div-view div-display')
      $('.close-slider').addClass('div-display')
      $('.main-header').addClass('div-none')
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  }
}

</script>



<style>

.main-header{
  width: 100%;
  position: fixed;
}

.user-info {
  color:#6F6F6F;	
  font-size: 18px;		
  text-align: center;
  text-transform: capitalize;
}

.fechaNav{
  float: left;
  margin-top: 30px;
}

.navbar-nav {
  padding-top: 12px;
}
.navbar{
  display: inherit !important;
}

.navbar.hidden-navbar {
  box-shadow: none;
  transform: translate3d(0, -100%, 0);
}

.logo-side {
  background-color: #031A3C !important;
  width:71px !important;
  height: 71px;
  float: left;
  font-size: 20px;
  line-height: 50px;
  text-align: center;
  padding-top: 11px;
  
}

.logo-side2 {
  width:60px !important;
  height: 60px;
  float: left;
  font-size: 20px;
  line-height: 50px;
  text-align: center;
  margin-left: 10px;
  margin-top: 10px;
}

.sidebar-mini.sidebar-collapse .main-header .navbar{
  margin-left:  0px;
  border: 1px solid #E2E2E2; 
  background-color: white !important;
  border-bottom: 1px solid #E2E2E2 !important;
  }

.title-header{
  padding-left: 30px;
  height: 38px;
  width: auto;
	color: #364A5D;
	font-size: 32px;
	font-weight: 600;
	letter-spacing: -0.77px;
  line-height: 38px;
  float: left;
}

.nav>li.user>a>.fa{
  color:#6F6F6F !important;
  position:relative;
  top: -4px;
  font-size: 18px !important;
}


.dropdown-menu-per{
  background:none !important;
}

.rectangle {	
  height: 51px;	
  width: 157px;	
  border: 1px solid #E2E2E2;	
  border-radius: 0 0 0 5px;	
  background-color: #FFFFFF;
  text-align: center;
  padding-top: 14px;
  margin-top: 14px;
}

.rectangle:not(.dontHover):hover{
  animation-duration: 100s;
}

.exit-icon::before{
    content: url("/static/img/icons/sign-in-alt.png");
}

.user-close{
  display: inline;
  padding-left: 15px;
  position: relative;
  top: -3px;
  animation: none;
}

.skin-green .main-header .navbar .nav>li>a:not(.dontEnabled):enabled{
  background:none;
}

.skin-green .main-header .navbar .nav>li>a:not(.dontEnabled):hover{
  background:none;
}

.navbar-custom-menu>.navbar-nav>li>.dropdown-menu{
  border: none !important;
}

.img-color
{
  filter: brightness(0) saturate(100%) invert(37%) sepia(98%) saturate(2005%) hue-rotate(92deg) brightness(91%) contrast(109%);
}

.user-label
{
  color:#009d00;
  font-weight: 700;
  text-transform: capitalize;
}

.menu-ora
{
  filter: brightness(0) saturate(100%) invert(34%) sepia(38%) saturate(3917%) hue-rotate(100deg) brightness(95%) contrast(109%);
  padding: 25px 15px;
  display: none;
}

@media (max-width: 767px){
.skin-green .main-header .navbar .dropdown-menu li a:hover {
    background-color: #FFFFFF;
}
}

@media (max-width: 991px){

  .main-header .navbar-custom-menu a, .main-header .navbar-right a{
    color: #009d00 !important;
    background-color: transparent;
  }
  .rectangle {	
    border: 1px solid #E2E2E2;	
    border-radius: 0 0 0 5px;	
    background-color: #FFFFFF;
    text-align: center;
    padding-top: 14px;
    margin-top: 0px;
  }

}

</style>



// WEBPACK FOOTER //
// NaviBarOrange.vue?5a803a92